export default {
    data: () => ({
        translations: {
            regionName: {
                el: "Όνομα Περιφέρειας",
                en: "Region Name",
                it: "Nome della regione"
            },
            addRegion: {
                el: "Προσθήκη Περιφέρειας",
                en: "Add Network Region",
                it: "Aggiunta di una regione"
            },
            updateRegion: {
                el: "Επεξεργασία Περιφέρειας",
                en: "Update Network Region",
                it: "Aggiorna regione"
            },
            region: {
                el: "Περιφέρεια",
                en: "Network Region",
                it: "Regione"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            update: {
                el: "Επεξεργασία",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
